<template>
    <v-dialog v-model="show" max-width="500">
        <v-card class="v-card--dialog">
            <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>

            <div class="v-card--dialog__body">
                <section class="page-section page-section--sm pt-0">
                    <div class="mb-10px">
                        <h3 class="tit tit--xs">회원검색</h3>
                    </div>
                    <div>
                        <v-row align="center" class="row--x-small">
                            <v-col>
                                <v-text-field v-model="filter.searchValue" placeholder="이름 또는 아이디" append-icon="mdi-magnify" outlined hide-details clearable @input="search"/>
                            </v-col>
                        </v-row>
                    </div>
                </section>

                <section class="page-section page-section--sm">
                    <div class="mb-10px mb-md-20px">
                        <h3 class="tit tit--xs">최근선물한 회원</h3>
                        <v-divider class="grey lighten-1 mt-10px"></v-divider>
                    </div>
                    <div>
                        <v-list v-if="me?.recentUser.length" v-model="selected" outlined>
                            <v-list-item v-for="user, index in me?.recentUser" :key="index" class="py-1" :value="user" @click="selected = user">
                                <v-list-item-avatar color="primary"><v-icon color="white">mdi-account</v-icon></v-list-item-avatar>
                                <v-list-item-title>
                                    <div>{{ user.name }} ({{ user.username }})</div>
                                    <v-list-item-subtitle class="pb-1">
                                        <div>{{ String(user?.phone || "").replace(/[^0-9]/g, '').replace(/([0-9]{3}).+([0-9]{4})/g, "$1****$2").phoneNumberFormat() }}</div>
                                    </v-list-item-subtitle>
                                </v-list-item-title>
                                <v-list-item-action>
                                    <v-icon v-if="selected && selected?.username == user?.username">mdi-check</v-icon>
                                </v-list-item-action>
                                <v-list-item-action @click="remove(user._id, index)">
                                    <v-icon>mdi-close</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </div>
                </section>

                <section class="page-section page-section--sm">
                    <div class="mb-10px mb-md-20px">
                        <h3 class="tit tit--xs">회원선택</h3>
                        <v-divider class="grey lighten-1 mt-10px"></v-divider>
                    </div>
                    <div>
                        <v-list v-if="members.length" v-model="selected" outlined>
                            <v-list-item v-for="member, index in members" :key="index" class="py-1" :value="member" @click="selected = member">
                                <v-list-item-avatar color="primary"><v-icon color="white">mdi-account</v-icon></v-list-item-avatar>
                                <v-list-item-title>
                                    <div>{{ member.name }} ({{ member.username }})</div>
                                    <v-list-item-subtitle class="pb-1">
                                        <div>{{ member.phone.phoneNumberFormat() }}</div>
                                    </v-list-item-subtitle>
                                </v-list-item-title>
                                <v-list-item-action>
                                    <v-icon v-if="selected && selected?.username == member?.username">mdi-check</v-icon>
                                </v-list-item-action>
                            </v-list-item>
                        </v-list>
                    </div>
                </section>
            </div>

            <div class="v-card--dialog__foot">
                <div class="v-card--dialog__foot">
                    <v-row class="row--x-small">
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-btn @click="select" color="primary">선택</v-btn>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
import api from "@/api";
export default {
    props: {
        me: { type: Object }
    },
    async mounted(){
        this.me.recentUser = this.me?.recentUser.splice(0.5)
        // await this.init()
    },
    data(){
        return {
            show: false,

            filter: {
                searchKey: "id-name",
                searchValue: null
            },
            members: [],
            selected: null,
            // me: null
        }
    },
    methods: {
        async init(){
            // let { me } = await api.v1.me.profile.get();
            // this.me = me
            this.members = [];
            this.selected = null;
            this.filter.searchValue = null;
        },
        async search(){
            if(this.filter.searchValue){
                let { members } = await api.v1.members.gets({
                    headers: { skip: 0, limit: 0 },
                    params: this.filter
                });
                this.members = members.filter(el => {
                    return el._id !== this.me._id
                })
            }
        },
        open(){
            this.show = true;
        },
        close(){
            this.show = false;
            this.init();
        },
        select(){
            if(this.selected) this.$emit("input", this.selected);
            this.close();
        },
        async remove(id, index){
            if(confirm('최근선물한 회원을 삭제하기겠습니까?')){
                let { member } = await api.v1.me.gifts.remove({
                    id
                })
                let { me } = await api.v1.me.profile.get();
                this.me = me
                this.me.recentUser = me.recentUser.filter(el => {
                return el.isBlock !== true && el.isWithdrawal !== true && el.isAutoBlock !== true
            })
                alert('최근선물한 회원을 삭제했습니다')
            }
        }
    }
}
</script>